import { observer } from 'mobx-react-lite'
import React from 'react'
import { Typography } from 'shared/ui'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import type { ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { IVRStore } from '../../store/IVRStore'

export const IVRNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof IVRStore)) return null

  const { step } = store

  return (
    <SmartCallActionNode
      iconProps={IVRStore.iconProps}
      title={IVRStore.title}
      placeholder={'Configure'}
      content={
        step.args?.greeting_audio_url ? (
          <Typography ariaLabel={'message'} variant={'body-md-regular'}>
            Route calls with a keypad menu
          </Typography>
        ) : null
      }
      {...props}
    />
  )
})
